// Whether a step is open: its default (the current step open, done steps folded) until the person
// opens or folds it; a change of state (ticked, undone) goes back to the default, every time.
import { useState } from 'react';

/** The person's choice counts only for the state they made it in; `seenState` is that state. */
export function foldOpen(
  seenState: string,
  state: string,
  chosen: boolean | null,
  openByDefault: boolean,
): boolean {
  return seenState !== state ? openByDefault : (chosen ?? openByDefault);
}

export function useStepFold(state: string, openByDefault: boolean) {
  // Adjusting state while rendering (no effect): forget the choice as soon as the state changes.
  const [seen, setSeen] = useState(state);
  const [chosen, setChosen] = useState<boolean | null>(null);
  if (seen !== state) {
    setSeen(state);
    setChosen(null);
  }
  const open = foldOpen(seen, state, chosen, openByDefault);
  const toggle = () => setChosen(!open);
  return { open, toggle };
}
